import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  fetchAuthenticated,
  getInitialMarketingAuthState,
  hasAccountCookie,
  resolveMarketingAuthState,
} from '../utils/marketingAuth';

const MarketingAuthContext = createContext(undefined);

export function MarketingAuthProvider({ children }) {
  const [state, setState] = useState(getInitialMarketingAuthState);
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function syncAuthState() {
      const authenticated = await fetchAuthenticated();

      if (!isMounted) {
        return;
      }

      setState(
        resolveMarketingAuthState(authenticated, hasAccountCookie()),
      );
      setIsCheckingSession(false);
    }

    syncAuthState();

    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      state,
      isCheckingSession,
    }),
    [state, isCheckingSession],
  );

  return (
    <MarketingAuthContext.Provider value={value}>
      {children}
    </MarketingAuthContext.Provider>
  );
}

export function useMarketingAuth() {
  const context = useContext(MarketingAuthContext);

  if (!context) {
    throw new Error('useMarketingAuth must be used within MarketingAuthProvider');
  }

  return context;
}
